<template>
    <div class="nr">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px" v-loading="loading">
            <el-form-item label="任务名称" prop="title">
                <el-input size="small" v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="任务描述" prop="taskDescribe">
                <el-input type="textarea" v-model="form.taskDescribe"></el-input>
            </el-form-item>
            <el-form-item label="领取地区">
                <el-select multiple size="small" clearable v-model="strCmid" style="width:100%;" @change="handleChange">
                    <el-option v-for="item in dqOptions" :key="item.cmid" :label="item.name" :value="item.cmid"></el-option>
                </el-select>
                <p style="color:#ff0000;"><b>* 不选则默认全部地区</b></p>
            </el-form-item>

            <el-form-item label="截止领取时间" prop="deadlineReceiveTime">
                <el-date-picker size="small" clearable
                    v-model="form.deadlineReceiveTime"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="截止上传时间" prop="deadlineUploadTime">
                <el-date-picker size="small" clearable
                    v-model="form.deadlineUploadTime"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
                <el-input type="textarea" v-model="form.remark" :rows="5"></el-input>
            </el-form-item>

            <!--<el-form-item label="PDF文档">
                <el-upload
                    class="upload-demo"
                    drag              :before-remove="handleRemove"          
                    action="#"  :before-upload="beforeUpload"
                        :file-list="fileList"  :limit="1" :on-exceed="handleExceed">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__tip" slot="tip">仅支持pdf格式文件</div>
                </el-upload>
            </el-form-item>-->
            <el-form-item>
                <el-button type="primary" @click="addTask">新增任务</el-button>
                <el-button @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>
        <div v-show="loading2"  style="z-index: 9000; position: fixed;background: rgba(0,0,0,0.05); top: 0; right: 0; bottom: 0; left: 0; overflow: auto;  margin: 0;">
                    <div class="load" style="position: absolute;padding-top: 40px; z-index: 2;    background: linear-gradient(128deg, rgb(255, 255, 255) 40%, rgb(230, 240, 252)); width: 700px; height: 400px; border-radius: 4px; top: 18vh; left: 50%;  margin-left: -350px;  text-align: center;">
                        <img style="margin: 30px auto 30px;" src="../../../assets/images/loading.png" />
                        <p style="font-weight: bold; font-size: 18px;">案卷正在上传，预计需要1~5分钟,请稍等...</p>
                    </div>
                </div>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    data() {
        return {
            dm:'',
            cmid:'',
            form: {
                title: '',
                remark: '',
                deadlineReceiveTime: '',
                deadlineUploadTime: '',
                strCmid:'',
                taskDescribe: ''
            },
            rules:{
                title: [
                    { required: true, message: '任务名称不能为空', trigger: 'blur' }
                ],
                strCmid: [
                    { required: true, message: '请选择至少一个地区', trigger: 'change' }
                ],
                deadlineReceiveTime: [
                    { required: true, message: '请选择截止领取时间', trigger: 'change' }
                ],
                deadlineUploadTime: [
                    { required: true, message: '请选择截止上传时间', trigger: 'change' }
                ]
            },
            dqOptions: [],
            strCmid:[],
            loading: false,
            loading2: false,
            fileList: [],
            files: '',
            fileName: '',
            fileUrl:'',
            baseUrl:''
        }
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.baseUrl = user.baseUrl
        this.getDqOptions()
    },
    methods: {
        getDqOptions() {
            axios({
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/nameList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {}
            })
            .then(res => {
                console.log(res)
                this.loading = false
                if(res.data.code == 0){
                    this.dqOptions = res.data.data
                }else{
                    this.$message.error(res.data.msg || '获取地区数据失败，请联系管理员！');
                }
            })
            .catch(error => {
                this.$message({
                    message: error.data.msg ? error.data.msg : '获取地区数据失败，请联系管理员！',
                    duration: 5000,
                    type: 'error'
                });
            });
        },
        beforeUpload(file){
            this.fileList = []
            this.files = file;
            const extension = file.name.split('.')[1] === 'pdf'
            // const isLt2M = file.size / 1024 / 1024 < 5
            if (!extension) {
            this.$message.warning('上传模板只能是 pdf格式!')
            return
            }
            // if (!isLt2M) {
            // this.$message.warning('上传模板大小不能超过 5MB!')
            // return
            // }
            this.fileList.push({name:file.name})
            // 防止添加超过一个文件
            //if (this.fileList.length >= 1) {
            //    this.$message.warning('只能上传一个文件，请先删除已上传的文件再尝试上传新文件。');
            //    return false;
            //} 

            this.fileName = file.name;

            this.submitAj()
            return false // 返回false不会自动上传
        }, 
        handleRemove(file, fileList) {
            if(file.status == 'success'){
                if(this.fileList.length > 1){
                    let isy = this.fileList.findIndex(item => {
                        return item.name == file.name
                    })
                    if(isy != -1){
                        this.fileList.splice(isy,1) 
                    }
                }
            }
        },
        handleExceed(files, fileList) {
            this.$message.warning('只能上传一个文件，请先删除已上传的文件再尝试上传新文件。');
        },
        async submitAj(){
            this.loading2 = true
            if(this.fileName == ""){
                this.$message.warning('请选择要上传的文件！')
                return false
            }
            let fileFormData = new FormData();
            fileFormData.append('files', this.files);//filename是键，file是值，就是要传的文件，test.zip是要传的文件名
            
            axios({
                timeout: 3600000, // 单位：毫秒（6 分钟）
                method: 'post',
                url: `https://xxswj.hzxhykj.com:9086/system/release/upload`,
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                data:fileFormData
            })
            .then(res => {
                console.log(res)
                this.loading2 = false;
                if(res.data.code == 0){
                    this.$message.success('新增成功！')
                    this.fileUrl = res.data.data.fileUrl
                    console.log(this.fileUrl,125)
                }else{
                    this.$message({
                        message: res.data.msg ? res.data.msg : '上传PDF文件失败，请重试！',
                        duration: 5000,
                        type: 'error'
                    });
                    this.fileList = [],
                    this.files = '',
                    this.fileName = '',
                    this.fileUrl =''
                }
            })
            .catch(error => {
                this.fileList = [],
                this.files = '',
                this.fileName = '',
                this.fileUrl =''
                this.loading2 = false
                this.$message({
                    message: error.data.msg ? error.data.msg : '上传PDF文件失败，请重试！',
                    duration: 5000,
                    type: 'error'
                });
            });
		},
        handleChange(){
            console.log(this.strCmid)
            if (Array.isArray(this.strCmid) && this.strCmid.length > 0) {
                this.form.strCmid = this.strCmid.join(',');
            } else {
                this.form.strCmid = '';
            }
            console.log(this.form.strCmid)
        },
        addTask(){
            this.$refs.form.validate(valid => {
                if (valid) {
                    axios({
                        timeout: 3600000, // 单位：毫秒（6 分钟）
                        method: 'post',
                        url: `https://xxswj.hzxhykj.com:9086/system/release/addRelease`,
                        headers: { // 添加请求头
                            "Content-Type": "application/json" // 明确声明为 JSON 格式
                        },
                        data: {
                            //fileUrl: this.fileUrl,
                            title: this.form.title,
                            remark: this.form.remark,
                            deadlineReceiveTime: this.form.deadlineReceiveTime,
                            deadlineUploadTime: this.form.deadlineUploadTime,
                            strCmid: this.form.strCmid,
                            taskDescribe: this.form.taskDescribe,
                        }
                    })
                    .then(res => {
                        console.log(res)
                        this.loading = false
                        if(res.data.code == 0){
                            this.$message.success('新增成功！')
                            this.$confirm('是否现在去查看添加的任务?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                this.$router.push({path: '/rwzx'})
                                this.resetQuery()
                            }).catch(() => {
                                this.resetQuery()          
                            });
                            
                        }else{
                            this.$message.error(res.data.msg || '新增失败，请重试');
                        }
                    })
                    .catch(error => {
                        this.loading = false
                        this.$message({
                            message: error.data.msg ? error.data.msg : '加载失败，请重试！',
                            duration: 5000,
                            type: 'error'
                        });
                    });
                }
            })
        },
        resetQuery(){
            this.form = {
                title: '',
                remark: '',
                deadlineReceiveTime: '',
                deadlineUploadTime: '',
                strCmid: '',
                taskDescribe: '',
            },
            this.loading2 = false,
            this.fileList = [],
            this.files = '',
            this.fileName = '',
            this.fileUrl =''
        }
    }
}
</script>

<style scoped>
.nr{margin: 20px auto;width: 700px;}
.nr >>> .upload-demo{
    margin-top: 10px;
}
.nr >>> .el-upload-dragger{
    width: 500px!important;
    height: 240px!important;
}
.nr >>> .el-upload-dragger .el-icon-upload{
    margin: 70px 0 16px;
}
.nr >>> .el-upload-list{
    width:80%;
}
</style>